import crrInputStyples from "./CrrInput.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

class CrrInputProps {
  /**
   * @type {?string}
   */
  placeholder;

  /**
   * @type {?string}
   */
  className;

  /**
   * @callback onKeyupCallback
   * @param {KeyboardEvent} event
   */
  /**
   * @type {onKeyupCallback}
   */
  onKeyUp;
}

/**
 * @param {CrrInputProps} props
 */
export default function CrrInput(props) {
  return (
    <Input
      onKeyUp={props.onKeyUp}
      placeholder={props.placeholder}
      className={`
                    ${crrInputStyples.input}
                    ${props.className}
                `}
      suffix={
        <SearchOutlined
          style={{
            fontSize: "20px",
            color: "#0058be",
            fontWeight: "600",
            cursor: "pointer",
          }}
        />
      }
    />
  );
}
